import { render, staticRenderFns } from "./ChooseTemplateModal.vue?vue&type=template&id=85fe9b7e&"
import script from "./ChooseTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ChooseTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports